import { NgModule } from '@angular/core';

import { SharedModule } from '../../shared';

import { ItemFamiliaRoutingModule } from './item-familia-routing.module';
import { ItemFamiliaComponent } from './item-familia.component';
import { ItemFamiliaFormComponent} from './form';

@NgModule({
    imports: [
        SharedModule,
        ItemFamiliaRoutingModule
    ],
    declarations: [
        ItemFamiliaComponent,
        ItemFamiliaFormComponent
    ]
})
export class ItemFamiliaModule { }
